import '@hotwired/turbo'

import '@/controllers'

import * as ActiveStorage from '@rails/activestorage'
ActiveStorage.start()
